import * as Api from "./client";
import { ApiEndpoint } from "./endpoints";

export interface ClientData {
	type: string;
	notificationToken: string;
}

export const authenticate = async (username: string, password: string) => {
	try {
		const res = await Api.post(ApiEndpoint.Login, {
			username,
			password
		});

		if (res.token && res.authInfo) {
			sessionStorage.setItem("token", res.token);
			sessionStorage.setItem("authInfo", JSON.stringify(res.authInfo));
			return true;
		}

		return false;
	} catch (_) {
		return false;
	}
};

export const checkLoginStatus = async () => {
	try {
		await Api.get(ApiEndpoint.Ping);

		return true;
	} catch (e) {
		return false;
	}
};

export const sendClientData = async (data: ClientData) => {
	try {
		await Api.post(ApiEndpoint.Clients, data);
	} catch (_) {}
};
